import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from "recharts";

const DashboardPieChart = ({ dashboarddata }) => {
  const COLORS = ["orange", "#5095FF", "#D9D9D9"];
  
  const data = [
    { name: "Total Paid", value: dashboarddata?.total_paid || 0, shortName: "Paid" },
    { name: "Total Escrow", value: dashboarddata?.total_escrow || 0, shortName: "Escrow" },
    { name: "Total Pending", value: dashboarddata?.total_pending || 0, shortName: "Pending" },
  ];

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);
  
  // Format currency
  const formatCurrency = (value) => {
    return `SAR${value.toLocaleString()}`;
  };

  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          startAngle={180}
          endAngle={0}
          innerRadius={60}
          outerRadius={80}
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
          
          {/* Center Label - Shows all three values */}
          <Label
            content={({ viewBox }) => {
              const { cx, cy } = viewBox;
              return (
                <g>
                  {/* Paid */}
                  <text
                    x={cx}
                    y={cy - 25}
                    textAnchor="middle"
                    fill="orange"
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    Paid
                  </text>
                  <text
                    x={cx}
                    y={cy - 10}
                    textAnchor="middle"
                    fill="orange"
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    {formatCurrency(data[0].value)}
                  </text>
                  
                  {/* Escrow */}
                  <text
                    x={cx}
                    y={cy + 15}
                    textAnchor="middle"
                    fill="#5095FF"
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    Escrow
                  </text>
                  <text
                    x={cx}
                    y={cy + 30}
                    textAnchor="middle"
                    fill="#5095FF"
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    {formatCurrency(data[1].value)}
                  </text>
                  
                  {/* Pending */}
                  <text
                    x={cx}
                    y={cy + 55}
                    textAnchor="middle"
                    fill="#D9D9D9"
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    Pending
                  </text>
                  <text
                    x={cx}
                    y={cy + 70}
                    textAnchor="middle"
                    fill="#D9D9D9"
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    {formatCurrency(data[2].value)}
                  </text>
                </g>
              );
            }}
          />
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DashboardPieChart;